import { useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "@material-ui/core/Button";
import LinkIcon from "@material-ui/icons/Link";

import styles from "./index.module.scss";

export default function SubjectListInput({ list, subjects, disabled, hideProjectTargetKpi,
  hideCurrentMetrics, ...props }) {
  const { t } = useTranslation();
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [currentActiveIndex, setCurrentActiveIndex] = useState(null);
  const [linkTextFieldValue, setLinkTextFieldValue] = useState("");

  const handleInsertLink = (index) => {
    setCurrentActiveIndex(index);
    setLinkTextFieldValue(list[index]["link"]);
    setDialogIsOpen(true);
  };

  return (
    <div className={styles.container}>
      <div className={styles.subjectList}>
        {list.map((item, index) => {
          return (
            <div key={index} className={styles.listItem}>
              <div className={styles.index}>
                <div>{index + 1}</div>
              </div>
              <div className={styles.listItemDetails}>
                <div className={styles.subjectName} title={item.subject}>
                  {item.subject}{item.sub_subject ? ' — ' + item.sub_subject : ''}
                </div>
                {!hideProjectTargetKpi && (
                  <div className={styles.subjectMetrics}>
                    <span>{t("growForm.projectTargetKpi")} </span>
                    <div
                      className={styles.subjectMetricsValue}
                      title={item.project_target_kpi}
                    >
                      <span>{item.project_target_kpi !== 'undefined' ? item.project_target_kpi : ""}</span>
                    </div>
                  </div>
                )}
                {!hideProjectTargetKpi && (
                  <div className={styles.subjectMetrics}>
                    <span>{t("growForm.mtd")} </span>
                    <div
                      className={styles.subjectMetricsValue}
                      title={item.mtd_metric}
                    >
                      <span>{item.mtd_metric !== 'undefined' ? item.mtd_metric : ""}</span>
                    </div>
                  </div>
                )}
                {!hideCurrentMetrics && (
                  <div className={styles.subjectMetrics}>
                    <span>{t("growForm.current")} </span>
                    <div
                      className={styles.subjectMetricsValue}
                      title={item.result_metrics}
                    >
                      <span>{item.result_metrics}</span>
                    </div>
                    {item.document_link && item.document_link.length > 0 && (
                      <Button
                        className={styles.viewLinkBtn}
                        variant="outlined"
                        name="subjects"
                        disableRipple
                        disableElevation
                        title={item.document_link}
                        onClick={() => {
                          window.open(item.document_link);
                        }}
                      >
                        <LinkIcon className={styles.viewLinkBtnIcon} />
                        <span className={styles.viewLinkBtnLabel}>
                          View link
                        </span>
                      </Button>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}